/**
 * Created by razial on 24.04.2025.
 */

const LocationMeta = function (config) {
    this.locationConfig = config;

    this.locationId = this.locationConfig.id;
    this.locationType = this.locationConfig.locationType;

    if (this.locationConfig.schedule) {
        this.schedule = {
            start: cleverapps.convertToTimezone(this.locationConfig.schedule.start).getTime(),
            finish: cleverapps.convertToTimezone(this.locationConfig.schedule.finish).getTime()
        };
    }

    this.updateInfo({
        version: this.locationConfig.version,
        slot: this.locationConfig.slotId
    });
};

LocationMeta.prototype.updateInfo = function (data) {
    data = data || {};

    // restore wrong slots for unknown locations
    if (!this.locationConfig.isMain && data.slot === "" && !data.version && !data.started && !data.finished) {
        data.slot = this.locationConfig.slotId;
    }
    // if slot changed for new version of location
    if (data.finished && this.locationConfig.version > data.version) {
        data.slot = this.locationConfig.slotId;
    }

    this.version = data.version || 0;
    this.slotId = data.slot !== undefined ? data.slot : "unknown";
    this.started = data.started || false;
    this.finished = data.finished || false;

    if (this.locationConfig.unknown || this.version > this.locationConfig.version || this.version === this.locationConfig.version && this.slotId !== this.locationConfig.slotId) {
        this.unknown = data;
        return;
    }

    if (this.isActive()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.LOCATION.ACTIVE, {
            location: this.locationId,
            key: cleverapps.EVENTS.LOCATION.ACTIVE + this.locationId
        });
    }
};

LocationMeta.prototype.getInfo = function () {
    if (this.slotId === "unknown") {
        return undefined;
    }

    if (this.isUnknown()) {
        return this.unknown;
    }

    if (!this.isStarted() && !this.isFinished()) {
        return undefined;
    }

    return {
        version: this.version || undefined,
        slot: this.slotId || undefined,
        started: this.started || undefined,
        finished: this.finished || undefined
    };
};

LocationMeta.prototype.reset = function () {
    this.version = this.locationConfig.version;
    this.slotId = this.locationConfig.slotId;
    this.started = false;
    this.finished = false;
    this.unknown = undefined;
};

LocationMeta.prototype.start = function (date) {
    this.updateInfo({
        version: this.locationConfig.version,
        slot: this.locationConfig.slotId,
        started: date
    });
};

LocationMeta.prototype.finish = function (date) {
    this.updateInfo({
        version: this.version,
        slot: this.slotId,
        finished: date
    });
};

LocationMeta.prototype.isUnknown = function () {
    return Boolean(this.locationConfig.unknown || this.unknown);
};

LocationMeta.prototype.isOld = function () {
    return !this.isUnknown() && this.locationConfig.version > this.version;
};

LocationMeta.prototype.isStarted = function () {
    return !this.isUnknown() && this.started !== false;
};

LocationMeta.prototype.isFinished = function () {
    return !this.isUnknown() && this.finished !== false;
};

LocationMeta.prototype.isActive = function () {
    return !this.isUnknown() && !this.isOld() && !this.isFinished() && this.isStarted();
};

LocationMeta.prototype.isPassed = function () {
    return !this.isUnknown() && this.isFinished() && !this.isPermanent();
};

LocationMeta.prototype.isExpired = function () {
    return !this.isUnknown() && !this.locationConfig.isMain && !this.isPermanent() && this.getTimeLeft() === 0;
};

LocationMeta.prototype.isPermanent = function () {
    return !this.isUnknown() && this.locationConfig.permanent;
};

LocationMeta.prototype.getStartTime = function () {
    return !this.isUnknown() && this.started || 0;
};

LocationMeta.prototype.getFinishTime = function () {
    if (this.isUnknown()) {
        return 0;
    }
    
    if (this.finished) {
        return this.finished;
    }

    let finishTime = 0;

    if (this.schedule) {
        finishTime = this.schedule.finish;
    }

    if (this.locationConfig.duration) {
        finishTime = this.started + cleverapps.parseInterval(this.locationConfig.duration);
    }

    if (this.locationConfig.retire) {
        finishTime = Math.min(finishTime, new Date(this.locationConfig.retire).getTime());
    }

    return finishTime;
};

LocationMeta.prototype.getTimeLeft = function () {
    return Math.max(0, this.getFinishTime() - Date.now());
};

LocationMeta.prototype.getTimeToNextStart = function () {
    if (this.isUnknown()) {
        return undefined;
    }

    if (this.schedule && this.schedule.finish > Date.now()) {
        return Math.max(0, this.schedule.start - Date.now());
    }

    return undefined;
};

LocationMeta.prototype.canStart = function () {
    if (this.isUnknown()) {
        return false;
    }

    if (this.schedule && (this.schedule.start >= Date.now() || this.schedule.finish < Date.now())) {
        return false;
    }

    if (this.isPassed()) {
        return false;
    }

    if (this.locationConfig.disableForNewUsers) {
        return false;
    }

    const retire = this.locationConfig.retire ? new Date(this.locationConfig.retire).getTime() : 0;
    const duration = this.locationConfig.duration ? cleverapps.parseInterval(this.locationConfig.duration) : 0;

    if (retire && duration && Date.now() + duration + LocationMeta.AUTO_REMOVE_TIMEOUT >= retire) {
        return false;
    }

    if (retire && Date.now() >= retire) {
        return false;
    }

    if (this.locationConfig.abTest) {
        const group = ABExperiments.Tests && cleverapps.abExperiments.getGroup(ABExperiments.Tests[this.locationConfig.abTest]);
        if (group !== "A") {
            return false;
        }
    }

    return !this.locationConfig.available || cleverapps.user.checkAvailable(this.locationConfig.available);
};

LocationMeta.prototype.canRemoveSilently = function () {
    if (this.isUnknown()) {
        return false;
    }

    if (!this.isStarted() || !this.isExpired()) {
        return false;
    }

    if (this.locationConfig.retire && new Date(this.locationConfig.retire).getTime() < Date.now()) {
        return true;
    }

    if (this.getFinishTime() + LocationMeta.AUTO_REMOVE_TIMEOUT < Date.now()) {
        return true;
    }

    if (this.locationType === "merge") {
        if (this.locationConfig.slot.load("expedition") !== this.locationId) {
            return true;
        }
    }

    return false;
};

LocationMeta.AUTO_REMOVE_TIMEOUT = cleverapps.parseInterval("7 days");
